import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_danhmucchitieubaocao } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-danhmuc-cauhinhchitieubaocaoedit',
  templateUrl: './cauhinhchitieubaocaoedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./cauhinhchitieubaocaoedit.component.scss'],
  providers: [ListService, Repository]
})


export class cauhinhchitieubaocaoeditComponent implements OnInit {

  currentUser: any;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputdonvitinhs: any;
  inputparents: any;
  inputtinhchats: any;
  inputmanguons: any;
  inputcapphats: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, IDCHITIEU: null, MAREPORT: null, MA: null, TEN: null, CONGMASO: null, CONGMASO2: null
    , STT: null, CHUDAM: null, Parent: null, RECORDTYPE: null, THEOTHONGTU: null
    , DonViTinhId: null, DonViTinh05Id: null, MucTrichLap: null
    , Code: null
  };
  nhomdtid: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };


  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('slTinhChat', { static: false }) slTinhChat: NgSelectComponent;
  @ViewChild('slMaNguon', { static: false }) slMaNguon: NgSelectComponent;
  @ViewChild('slCapPhat', { static: false }) slCapPhat: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();



  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }

  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;

  loadDataInit(id: string, nhomdoituongid: string, mabaocao: string,donviid: string) {

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    this.nhomdtid = nhomdoituongid;
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);

  

    this.repo.postRequest("api/chitieubaocao/getdonvitinh/", { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputdonvitinhs = response;
      });


    this.doituongSelect = {
      Id: null, IDCHITIEU: null, MAREPORT: mabaocao, MA: null, TEN: null, CONGMASO: null, STT: null
      , CHUDAM: null, Parent: null, CONGMASO2: null, RECORDTYPE: null, THEOTHONGTU: null
      , DonViTinhId: null, DonViTinh05Id: null, MucTrichLap: null
      , Code: null
    };

    if (id === null) {
      console.log("vao loaddatainit" + id);
      this.doituongSelect.THEOTHONGTU = "107";
      if (this.currentUser.nam_ke_toan >= 2025)
        this.doituongSelect.THEOTHONGTU = "24";
      

      this.repo.postRequest("api/chitieubaocao/ChiTieuBaoCao_SINHIDCHITIEU/", { Ma: mabaocao, DonViId: donviid })
        .subscribe(response => {
          this.doituongSelect.IDCHITIEU = response[0].IDCHITIEU;
          this.doituongSelect.STT = response[0].STT;
        });
      //this.doituongSelect.STT = 1;
      }
    else {
      console.log(id);
      this.repo.getRequest("api/chitieubaocao/getbyid/" + id)
        .subscribe(response => {
          console.log(response);
          this.doituongSelect.Id = id;
          this.doituongSelect.IDCHITIEU = response.IDCHITIEU;
          this.doituongSelect.MAREPORT = response.MAREPORT;
          this.doituongSelect.MA = response.MA;
          this.doituongSelect.TEN = response.TEN;
          this.doituongSelect.CHUDAM = response.CHUDAM;
          this.doituongSelect.STT = response.STT;
          this.doituongSelect.CONGMASO = response.CONGMASO;
          this.doituongSelect.CONGMASO2 = response.CONGMASO2;
          this.doituongSelect.MASTT = response.MASTT;
          this.doituongSelect.Parent = response.Parent;
          //this.doituongSelect.INDEXORDER = response.INDEXORDER;
          this.doituongSelect.RECORDTYPE = response.RECORDTYPE;
          //this.doituongSelect.STYLE = response.STYLE;
          //this.doituongSelect.NHOM = response.NHOM;
          //this.doituongSelect.QUYETDINH = response.QUYETDINH;
          this.doituongSelect.THEOTHONGTU = response.THEOTHONGTU;
          //this.doituongSelect.TENSQL = response.TENSQL;
          //this.doituongSelect.TENNGOAINGU = response.TENNGOAINGU;
          this.doituongSelect.DonViTinhId = response.DonViTinhId;
          this.doituongSelect.DonViTinh05Id = response.DonViTinh05Id;
          this.doituongSelect.MucTrichLap = response.MucTrichLap;
          this.doituongSelect.Code = response.Code != null ? response.Code : response.code;


        });
    }


  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.TEN == null || this.doituongSelect.TEN == "") {
      swal('Lỗi!', 'Vui lòng nhập tên chỉ tiêu báo cáo!.', 'error');
      return;
    }
    console.log(this.doituongSelect);
    this.repo.postRequest("api/chitieubaocao/addorupdate", this.doituongSelect)
      .subscribe(response => {
        console.log(response);
        if (response.indexOf("-") !== -1) {
          this.doituongSelect.Id = response;
          this.save.emit(this.doituongSelect);
        }
        else
          swal('Lỗi!', response, 'error');
      });
  }







}
